module.exports = __webpack_public_path__ + "static/media/everyday_digital.f872ed9d.png";